// extracted by mini-css-extract-plugin
module.exports = {"feedback":"FeedbackItem_feedback__AfFIl","divider":"FeedbackItem_divider__EG0KB","description":"FeedbackItem_description__hVBO3"};